module.exports = __webpack_public_path__ + "static/assets/296f9151c7e3d6d6c585651fe6e2bf58.png";